import { Component } from '@angular/core';
import {ComponentType} from "@angular/cdk/overlay";
import {MetricsDimensionsPickerComponent} from "../../../metrics-dimensions-picker/metrics-dimensions-picker.component";
import {Observable} from 'rxjs';
import {ParamBaseComponent} from "../../../../bases/param-base-component";
import {MetricComponentObject, MetricComponentObjects} from '../../../../classes/metric-component-object';
import {selectDataSetMetricAttributedMetricsComponentObjects} from '../../../../store/dataSetMetrics/dataSetMetrics.selectors';

@Component({
  selector: 'app-param-attributed-metric',
  templateUrl: './report-param-attributed-metric.component.html',
  styleUrls: ['./report-param-attributed-metric.component.scss']
})
export class ReportParamAttributedMetricComponent extends ParamBaseComponent {
  public readonly component: ComponentType<MetricsDimensionsPickerComponent> = MetricsDimensionsPickerComponent;
  public readonly options$: Observable<MetricComponentObjects> = this._store.select(selectDataSetMetricAttributedMetricsComponentObjects);

  public readonly textGetter: (metric: MetricComponentObject) => string = (metric: MetricComponentObject): string => metric.payload.attributes.name;
}
